import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';
// import DateFnsUtils from '@date-io/date-fns';
// import ptBRLocale from "date-fns/locale/pt-BR";
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
// } from '@material-ui/pickers';



class ListaPropostas extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      data: 'loading',
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,
      disabledInput: true,
      disabledInputValuePlan: true,

      // Paginação do servidor
      currentPage: 0,
      itemsPerPage: 10,
      totalItems: 0,
      
      showDateActive: false,
      isDefaultUser: false,

      date: {
        startDate: {value: null, error: ''},
        endDate: {value: null, error: ''},
      },
      loadingTable: null,
      showSearchDate: false,
      searchField: 'firstName', // Default search field
      isSearching: false, // Indicador de loading durante pesquisa
      isPaginationLoading: false, // Indicador de loading durante mudanças de paginação
    };

    this.errorField = {
      
    };

    this.errorFormat = {
      
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
      theadTh:{
        height: 35,
      },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '5px',
        letterSpacing: 0,
        textTransform: 'uppercase',
        padding: 0,
        height: 35,
        fontSize: 8.5,
      }
    }

  }


  componentDidMount() {
    let userType = localStorage.getItem('planos_y');
    let state = this.state;

    // Define se é um usuário admin
    state.isDefaultUser = userType !== 'SALESMAN' && userType !== 'BROKER';

    // Verifica se exibe ou não a coluna 'Corretora'
    // A lógica final será definida na resposta da API baseada no brokerDefault
    if (state.isDefaultUser)
      state.showColBroker = true;
    else
      state.showColBroker = false;

    // Verifica se exibe ou não a coluna 'Vendedor'
    if (userType === 'SALESMAN') {
      state.showColSalesman = false;
      // Permite edição de campos do resumo da proposta
      state.disabledInput = false;
      state.disabledInputValuePlan = true;
    }
    else
      state.showColSalesman = true;

    // Verifica exibição de primeiro pagamento
    if (userType === 'REGISTER' || userType === 'AFTER SALES') {
      state.showFirstPayment = true;
      // Permite edição de campos do resumo da proposta
      state.disabledInput = false;
      state.disabledInputValuePlan = false;
    }

    this.setState(state);

  
    this.getFilterName();
    this.getData(true, false);
  }

  // Função para aplicar máscara do CPF
  applyCpfMask(value) {
    // Remove todos os caracteres não numéricos
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara: XXX.XXX.XXX-XX
    if (numbers.length <= 3) {
      return numbers;
    } else if (numbers.length <= 6) {
      return numbers.replace(/(\d{3})(\d{1,3})/, '$1.$2');
    } else if (numbers.length <= 9) {
      return numbers.replace(/(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
    } else {
      return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
    }
  }

  // Função para manipular mudança no campo de seleção (dropdown)
  handleSearchFieldChange = (e) => {
    this.setState({
      searchField: e.target.value,
      searchTerm: '' // Limpa o campo de busca ao trocar o tipo
    });
  }

  // Função para manipular a pesquisa
  handleSearch = (e) => {
    let searchValue = e && e.target ? e.target.value : '';
    
    // Aplica máscara se o campo de busca for CPF
    if (this.state.searchField === 'cpf') {
      searchValue = this.applyCpfMask(searchValue);
    }
    
    // Reseta a paginação ao pesquisar
    this.setState({
      currentPage: 0,
      searchTerm: searchValue,
      isSearching: true // Ativa o loading
    }, () => {
      // Debounce para evitar muitas requisições
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getData(true, false);
      }, 500);
    });
  }

  getFilterName() {
    // pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    let page = this.props.history.location.pathname;

    page = page.split('/');
    page = page[page.length - 1];

    state.page = page;

    if (page === "geralpf") {
      state.titlePage = "TODAS AS PROPOSTAS - PF";
      state.apiPage = 'all';
    }
    else if (page === "pendentespf") {
      state.titlePage = configBase.statusPendente+" - PF";
      state.apiPage = 'awaitingSolution';
    }
    else if (page === "emaverbacaopf") {
      state.titlePage = configBase.statusEmAverbacao+" - PF";
      state.apiPage = 'inAverbation';
    }
    else if (page === "funcempresa") {
      state.titlePage = configBase.statusFuncEmpresa;
      state.apiPage = 'funcEmpresas';
    }
    else if (page === "indeferidaspf") {
      state.titlePage = configBase.statusIndeferida+" - PF";
      state.apiPage = 'pending';
    }
    else if (page === "emanalisepf") {
      state.titlePage = configBase.statusEmAnalise+" - PF";
      state.apiPage = 'waitingConfirmation';
    }
    else if (page === "novaspf") {
      state.titlePage = configBase.statusNova+" - PF";
      state.apiPage = 'clientConfirmation';
      // Verifica exibição da coluna Estágio
      state.showColStage = true;
    }
    else if (page === "implantadaspf") {
      state.titlePage = configBase.statusImplementadas+" - PF";
      state.apiPage = 'implantedContracts';
      state.showDateActive = true;
      state.showSearchDate = false;
      state.showColCods = true;
    }
    else if (page === "canceladaspf") {
      state.titlePage = configBase.statusCanceladas+" - PF";
      state.apiPage = 'canceledContracts';
    }
    else 
      state.titlePage = "PÁGINA INCORRETA";
      

    this.setState(state);
  }

  getData(table=false, searchDate=false) {
    // Para o tipo dos dados da tabela
    let typeBox = this.state.apiPage;
    let url = configBase.api + 'FinancialManagers/getProposalAll?access_token='+localStorage.getItem('planos_t');
    // Parâmetros para enviar
    let filter = {
      userId: localStorage.getItem('planos_u'),
      limit: this.state.itemsPerPage,
      skip: this.state.currentPage * this.state.itemsPerPage
    };

    // Se houver um termo de busca
    if (this.state.searchTerm) {
      filter[this.state.searchField] = this.state.searchTerm;
    }

    if (typeBox !== null && typeBox.length > 0) {
      if (typeBox !== 'all') {
        filter.content = typeBox;
        url = configBase.api + 'Sales/dataDashboardFilter?access_token='+localStorage.getItem('planos_t');

        // Caso seja uma pesquisa com a data inicial e final
        if (searchDate === true) {
          filter.startDate = this.state.date.startDate.value;
          filter.endDate = this.state.date.endDate.value;
        }
      }
    }

    if (typeBox === null) {
      let state = this.state;
      state.data = 'zero';
      this.setState(state);
    }
    else {
      axios.post(url, filter)
      .then((response) => {
        let state = this.state;
        state.isSearching = false; // Finaliza o loading da pesquisa
        state.isPaginationLoading = false; // Finaliza o loading da paginação

        // Verifica se é usuário padrão (vendedor ou broker padrão)
        const isDefaultSalesman = response.data.salesmanDefault === true;
        const isDefaultBroker = response.data.brokerDefault === true;
        
        // Se for admin ou usuário padrão, mostra todas as opções
        if (state.isDefaultUser || isDefaultSalesman || isDefaultBroker) {
          state.showColSalesman = true;
          state.showColBroker = true;
        }
        
        // Garantir que a opção Corretora apareça para usuários admin
        if (state.isDefaultUser) {
          state.showColBroker = true;
        }
        

        // if (typeBox !== null && typeBox.length > 0 && typeBox !== 'all') {
        //   if (response.data[typeBox+'Data'].length === 0) {
        //     if (searchDate) {
        //       state.data = [];
        //       state.loadingTable = 'zero';
        //       state.totalItems = 0;
        //     }
        //     else {
        //       state.data = 'zero';
        //       state.totalItems = 0;
        //     }
        //   } else {
        //     this.setColorStatus(response.data[typeBox+'Data']);
        //     // Atualiza o total de itens
        //     state.totalItems = response.data.count;
        //   }
        // }
        // else {
        if (response.data.plans.length === 0) {
          state.data = 'zero';
          state.totalItems = 0;
        }
        else {
          this.setColorStatus(response.data.plans);
          state.totalItems = response.data.count;
        }
        // }

        if (table === true && state.showTable === false) {
          state.showTable = true;

          // A paginação agora é feita pelo servidor
          state.showTable = true;
        }

        state.loadingTable = null;
        this.setState(state);

      })
      .catch(function () {
        let state = this.state;
        state.data = 'error';
        state.isSearching = false; // Finaliza o loading da pesquisa mesmo em caso de erro
        state.isPaginationLoading = false; // Finaliza o loading da paginação mesmo em caso de erro
        this.setState(state);
      }.bind(this));
    }

  }

  searchByDate() {
    let state = this.state;

    // Verifica o campo de data inicial
    if (!state.date.startDate.value || state.date.startDate.error.length > 0)
      state.date.startDate.error = 'Campo obrigatório';
    else {
      // Verifica o campo de data final
      if (!state.date.endDate.value || state.date.endDate.error.length > 0) {
        state.date.endDate.error = 'Campo obrigatório';
      }
      else {
        let search = false

        // Verifica se a data final é maior que a data inicial
        if (moment(state.date.endDate.value).isAfter(state.date.startDate.value) === false) {
          // Mesmo dia
          if (state.date.endDate.value === state.date.startDate.value)
            search = true;
          else
            state.date.startDate.error = 'Data Inicial deve ser menor que Data Final';
        }
        else
          search = true;

        if (search) {
          state.date.startDate.error = '';
          state.date.endDate.error = '';
          state.loadingTable = 'loading';
          state.showTable = false;
          this.setState(state);

          this.getData(true, true);
        }
      }
    }

    this.setState(state);
  }

  updateFieldDate(field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    state.date[field].error = '';

    this.setState(state);

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      if (value.getTime() !== 0) {
        day = value.getDate();
        month = value.getMonth() + 1;
        year = value.getFullYear();

        if (day < 10)
          day = '0'+ day;
        if (month < 10)
          month = '0'+ month;

        state.date[field].value = year+'-'+month+'-'+day;
        this.validateDate(day+'/'+month+'/'+year, field);
      }
      else {
        state.date[field].value = value;
        state.date[field].error = 'Data inválida';
      }
    }
    else {
      state.date[field].value = value;
      state.date[field].error = 'Data inválida';
    }

    this.setState(state);
  }

  validateDate(date, field) {
    let dateReg = /^((((0?[1-9]|[12]\d|3[01])[.\-/](0?[13578]|1[02])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[.\-/](0?[13456789]|1[012])[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?\d{2}))|(29[.\-/]0?2[.\-/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    if (date.length > 0) {
      if(!dateReg.test(date)) {
        let state = this.state;
        state.date[field].error = 'Data inválida';
        this.setState(state);
      }
    }
  }

  setColorStatus(proposals) {
    let colors = {
      'PAGAMENTO PENDENTE': {color: configBase.bgPendente, name: configBase.statusPendente},
      'EM VALIDAÇÃO': {color: configBase.bgEmAnalise, name: configBase.statusEmAnalise},
      'PENDENTE': {color: configBase.bgIndeferida, name: configBase.statusIndeferida},
      'CANCELADO': {color: configBase.bgCanceladas, name: configBase.statusCanceladas},
      'EM AVERBAÇÃO': {color: configBase.bgEmAverbacao, name: configBase.statusEmAverbacao},
      'AGUARDANDO CONFIRMAÇÃO': {color: configBase.bgNova, name: configBase.statusNova},
      'NOVAS': {color: configBase.bgNova, name: configBase.statusNova}, // Adicionado mapeamento para NOVAS
      'ATIVO': {color: configBase.bgImplementadas, name: configBase.statusImplementadas},
      'FUNCIONÁRIO DE EMPRESA': {color: configBase.bgFuncEmpresa, name: configBase.statusFuncEmpresa},
    };
    let state = this.state;

    for (let i = 0; i < proposals.length; i++) {
      // Verifica se o status existe no mapeamento, senão usa valores padrão
      if (colors[proposals[i].status]) {
        proposals[i].color = colors[proposals[i].status].color;
        proposals[i].status = colors[proposals[i].status].name;
      } else {
        // Valores padrão para status não mapeados
        proposals[i].color = configBase.bgNova || '#f0f0f0';
        proposals[i].status = proposals[i].status || 'NOVAS';
      }
    }

    state.data = proposals;
  }

  sendDetails(salesId) {
    if (salesId != null) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumopf?p=${salesId}`);
    }
  }

  sendDetailsFm(financialManagerId) {
    this.props.history.push(`${process.env.PUBLIC_URL}/resumosimples?fm=${financialManagerId}`);
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          
          {/* ############# CAMPO DE PESQUISA - SEMPRE VISÍVEL ############# */}
          {this.state.data !== 'loading' && (
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <div style={{paddingBottom: 7, textAlign: 'left'}}>
                    <ReactHTMLTableToExcel
                      className="ReactHTMLTableToExcel"
                      table="table_id"
                      filename={this.state.titlePage}
                      sheet="tablexls"
                      buttonText={
                        <div>
                          <CloudDownloadIcon fontSize="large" />
                          <Typography variant="caption" display="block" gutterBottom>
                            EXPORTAR PARA EXCEL
                          </Typography>
                        </div>
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={7} lg={7}></Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} style={{marginBottom: 20, marginTop: 14}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <select
                      style={{
                        border: 'none',
                        background: 'transparent',
                        marginRight: '2px',
                        padding: '2px',
                        outline: 'none'
                      }}
                      value={this.state.searchField}
                      onChange={this.handleSearchFieldChange}
                    >
                      <option value="firstName">Nome Resp.</option>
                      <option value="cpf">CPF</option>
                      <option value="email">Email</option>
                      {(this.state.isDefaultUser || this.state.showColSalesman) && (
                        <option value="salesmanName">Vendedor</option>
                      )}
                      {(this.state.isDefaultUser || this.state.showColBroker) && (
                        <option value="brokerName">Corretora</option>
                      )}
                      <option value="namePlan">Plano</option>
                      <option value="proposalNumber">Proposta</option>
                    </select>
                    <InputBase
                      id="mySearchText"
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      value={this.state.searchTerm || ''}
                      onChange={this.handleSearch}
                      inputProps={{ 'aria-label': 'pesquisar propostas' }}
                    />
                  </Paper>
                </Grid>
              </Grid>
              
              {/* Loading durante pesquisa */}
              {this.state.isSearching && (
                <Grid container spacing={0} style={{marginTop: 10}}>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                    <LinearProgress />
                    <Typography variant="caption" display="block" style={{textAlign: 'center', marginTop: 5, color: '#757575'}}>
                      Pesquisando...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                </Grid>
              )}
            </div>
          )}
          {/* ############# FIM CAMPO DE PESQUISA ############# */}

          {
          this.state.data === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO PROPOSTAS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.data === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar lista de propostas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
                !this.state.isSearching && (
            <div id="listaPropostaTabela">
              {/* Loading indicator para paginação - aparece no lugar da tabela */}
              {this.state.isPaginationLoading && (
                <Grid container spacing={0} style={{marginTop: 40}}>
                  <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center'}}>
                    <LinearProgress />
                    <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                      CARREGANDO...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                </Grid>
              )}
              {/* ############# CSS PARA DATATABLE ############# */}
              <link
                rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
              />
              <link
                rel="stylesheet" type="text/css"
                href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
              />
              {/* ############# CSS PARA DATATABLE ############# */}

              {
                this.state.loadingTable === 'loading' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                  <LinearProgress />
                  <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                    BUSCANDO PROPOSTAS...
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
                ) : (
                  this.state.loadingTable === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
                  ) : (
                <div style={{display: this.state.isPaginationLoading ? 'none' : 'block'}}>  
                  <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                    <thead style={{backgroundColor: configBase.corPrincipal}}>
                      <tr style={this.styles.theadTr}>
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block"
                            gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Data
                          </Typography>
                        </th>

                    {
                      this.state.showDateActive === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Implantado
                      </Typography>
                    </th>
                      )
                    }

                    {
                      this.state.showDateActive === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Cód. S4E
                      </Typography>
                    </th>
                      )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Proposta
                      </Typography>
                    </th>
                    {
                      this.state.showColBroker === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Corretora
                      </Typography>
                    </th>
                      )
                    }

                    {
                    this.state.showColSalesman === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Vendedor
                      </Typography>
                    </th>
                    )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block"
                        gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Resp. Financeiro
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        CPF
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Plano
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Vidas
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Nosso Número
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Aditivo
                      </Typography>
                    </th>
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Valor
                      </Typography>
                    </th>

                    {
                      this.state.showColStage === true && (
                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Estágio
                      </Typography>
                    </th>
                      )
                    }

                    <th style={this.styles.theadTh}>
                      <Typography
                        variant="button" display="block" gutterBottom
                        style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                      >
                        Status
                      </Typography>
                    </th>
                  </tr>
                </thead>

                <tbody>
                {this.state.data.map((item, index) =>
                  <tr
                    id={'row_sales_'+item.salesId}
                    key={index}
                    className="row_table"
                    onClick={
                      item.salesId === null ? (
                        this.sendDetailsFm.bind(this, item.financialManagerId)
                      ) : (
                        this.sendDetails.bind(this, item.salesId)
                      )
                    }
                    style={{cursor:'pointer', height: 35, padding: 0}}
                  >
                    <td style={this.styles.tdDate}>
                      {item.date}
                    </td>

                    {
                      this.state.showDateActive === true && (
                    <td style={this.styles.tdDate}>
                      {item.dateActive}
                    </td>
                      )
                    }

                    {
                      this.state.showDateActive === true && (
                    <td style={{padding: 0, height: 35}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.codeSaveS4Contract}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.proposalNumber}
                      </Typography>
                    </td>

                    {
                      this.state.showColBroker === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.broker}
                      </Typography>
                    </td>
                      )
                    }

                    {
                      this.state.showColSalesman === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.salesman}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.financialManager}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.cpf}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.plan}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.lives}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.nossoNumero}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.aceiteAditivoCarencia ? 'Sim' : 'Não'}
                      </Typography>
                    </td>
                    {/* <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.nsu}
                      </Typography>
                    </td>
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.autorizacaoCodigo}
                      </Typography>
                    </td> */}
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}} data-order={item.value.replace(',', '')}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {'R$ ' + item.value}
                      </Typography>
                    </td>

                    {
                      this.state.showColStage === true && (
                    <td style={{padding: 0, height: 35, whiteSpace: 'normal'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, fontSize: 8.5}}
                      >
                        {item.stageForm}
                      </Typography>
                    </td>
                      )
                    }

                    <td style={{padding: 0, height: 35, whiteSpace: 'nowrap'}}>
                      <Typography
                        variant="overline" display="block" gutterBottom
                        style={{color: '#757575', margin:0, marginRight: 5, fontSize: 8.5}}
                      >
                        <span
                          style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                        >
                          {item.status}
                        </span>
                      </Typography>
                    </td>
                  </tr>
                )}
                    </tbody>
                  </table>

                  <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                    <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                      <label htmlFor="itemsPerPage">Linhas por página: </label>
                      <select 
                        value={this.state.itemsPerPage}
                        onChange={(e) => {
                          this.setState({
                            itemsPerPage: parseInt(e.target.value),
                            currentPage: 0,
                            isPaginationLoading: true
                          }, () => this.getData(true, false));
                        }}
                        style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}
                      >
                        <option value="10">10</option>
                        <option value="35">35</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span style={{marginLeft: 15}}>
                        {this.state.currentPage * this.state.itemsPerPage + 1}-
                        {Math.min((this.state.currentPage + 1) * this.state.itemsPerPage, this.state.totalItems)}
                      </span>
                      {' '}de{' '}
                      <span>{this.state.totalItems}</span>
                      <button 
                        onClick={() => {
                          if (this.state.currentPage > 0) {
                            this.setState({
                              currentPage: this.state.currentPage - 1,
                              isPaginationLoading: true
                            }, () => this.getData(true, false));
                          }
                        }}
                        disabled={this.state.currentPage === 0}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: this.state.currentPage === 0 ? 'default' : 'pointer',
                          opacity: this.state.currentPage === 0 ? 0.5 : 1
                        }}
                      >
                        <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small">
                          <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
                        </svg>
                      </button>
                      <button 
                        onClick={() => {
                          if ((this.state.currentPage + 1) * this.state.itemsPerPage < this.state.totalItems) {
                            this.setState({
                              currentPage: this.state.currentPage + 1,
                              isPaginationLoading: true
                            }, () => this.getData(true, false));
                          }
                        }}
                        disabled={(this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 'default' : 'pointer',
                          opacity: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 0.5 : 1
                        }}
                      >
                        <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small">
                          <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                  </div>
                  )
                )
              }     
            </div>
                )
              )
              )
            )
          }
          </div>
        </div>
      </MainLayout>
    );

  }

}

ListaPropostas.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostas);
